import type { Size } from "@simplybusiness/mobius";
import { Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useRef, useEffect } from "react";
import { useSetAtom } from "jotai";
import { LinkOrButton } from "../LinkOrButton";
import type { NextActionProps } from "./types";
import { chevronRight } from "@simplybusiness/icons";
import { useShouldBlockSubmission } from "../../../../../hooks/useShouldBlockSubmission";
import { useQuestionnaireNavigation } from "../../../../../features/questionnaire";
import { nextButtonRefAtom } from "../../state/nextButtonRefAtom";

export const NextAction = (props: NextActionProps) => {
  const {
    label = "Next",
    icon = chevronRight,
    iconSize = "xs",
    buttonProps,
    className,
  } = props;

  const { handleNextClick } = useQuestionnaireNavigation();
  const shouldBlockSubmission = useShouldBlockSubmission();
  const setNextButtonRef = useSetAtom(nextButtonRefAtom);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Sync ref to Jotai atom and cleanup on unmount
  useEffect(() => {
    setNextButtonRef(buttonRef.current);
    return () => setNextButtonRef(null);
  }, [setNextButtonRef]);

  const classes = classNames("mobius-actions__next", className);

  return (
    <LinkOrButton
      {...buttonProps}
      ref={buttonRef}
      isDisabled={shouldBlockSubmission}
      isLoading={shouldBlockSubmission}
      onClick={handleNextClick}
      className={classes}
      size={"md" as Size}
    >
      {label}
      {icon && (
        <Icon icon={icon} size={iconSize} title="Continue to next section" />
      )}
    </LinkOrButton>
  );
};
